import { translate as t } from '@thoughtspot/i18n';
import { UserAction, userActionTypeEnum, userActionTypes, } from '@thoughtspot/metrics';
import { Tab, TabHeaderHorizontalAlignment, TabTrayLayout, TabTraySize, } from '@thoughtspot/radiant-react/widgets/tab';
import { isCustomChartEnabled, isCustomRegionEnabled, isOrgUiEnabled, } from '@thoughtspot/session-service';
import React from 'react';
import { BasePageContext } from "../../contexts/basepage-context";
import { AdminContextProvider, useAdminContext } from "../../contexts/context";
import { ErrorBoundary } from '../error-boundary/error-boundary.container';
import { Header } from '../system/common';
import { Mode } from '../system/common/constants';
import styles from './chart-customization.module.scss';
import { CustomChartContainer } from './custom-chart/custom-chart.container';
import { GeoMapContainer } from './geomap';
import { ChartCustomizationSettingsTab } from './settings';
const getTabs = (currentOrgId) => {
    const tabs = [];
    const { ...adminContext } = useAdminContext();
    if (isCustomRegionEnabled()) {
        tabs.push({
            id: 'geomaps',
            title: t('adminSection.chartCustomization.geomaps.title'),
            component: React.createElement(GeoMapContainer, { currentOrgId: currentOrgId }),
            trackId: userActionTypes.ADMIN_GEO_MAPS.name,
        });
    }
    if (isCustomChartEnabled()) {
        tabs.push({
            id: 'custom-charts',
            title: t('adminSection.chartCustomization.customCharts.title'),
            component: (React.createElement(AdminContextProvider, { ...adminContext },
                React.createElement(ErrorBoundary, null,
                    React.createElement(CustomChartContainer, { currentOrgId: currentOrgId })))),
            trackId: userActionTypes.ADMIN_CUSTOM_CHARTS.name,
        });
    }
    const isAllOrgsContext = !isOrgUiEnabled() ||
        currentOrgId === undefined ||
        currentOrgId === -1;
    if (isAllOrgsContext) {
        tabs.push({
            id: 'settings',
            title: t('adminSection.chartCustomization.settings.title'),
            component: React.createElement(ChartCustomizationSettingsTab, null),
            trackId: undefined,
        });
    }
    return tabs;
};
export const ChartCustomization = ({ currentOrgId, }) => {
    const { metricsService } = BasePageContext();
    const renderTabs = () => {
        const tabs = getTabs(currentOrgId);
        return (React.createElement(Tab, { layout: TabTrayLayout.Horizontal, size: TabTraySize.Medium, selectedTabId: tabs[0].id, headerAlignment: TabHeaderHorizontalAlignment.LEFT, className: styles.chartCustomizationTab }, tabs.map(({ id, title, component, trackId }) => (React.createElement(Tab.Item, { key: id, id: id, tabBottomBorder: true, tooltipText: title, name: title, onTabItemClick: () => {
                if (!trackId)
                    return;
                metricsService.collectEvent(new UserAction(userActionTypeEnum.CLICK), {
                    trackId,
                });
            } }, component)))));
    };
    return (React.createElement("div", { className: styles.chartCustomizationViewContainer },
        React.createElement(Header, { title: t('adminSection.chartCustomization.title'), titleSize: "large", isFullWidth: true, mode: Mode.VIEW }),
        renderTabs()));
};
//# sourceMappingURL=chart-customization.container.js.map